module.exports = __webpack_public_path__ + "static/media/emmamainfloor.960ccf19.jpg";